import * as React from 'react';
const PuntureDiMedusaIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}`}</style>
    </defs>
    <path
      d="M99.8 84.63c-12.05 19.21-7.28 30.34-25.69 51.74"
      className="prefix__cls-1"
    />
    <path
      d="M111.26 96.15c-13.98 8.09-30.87 8.15-42.42 20.3M115.92 101.98c-19.85 13.45-31.23 9.19-53.62 29.39"
      className="prefix__cls-1"
    />
    <path
      d="M105.58 90.55c-7.72 14.14-6.98 30.31-19.05 42.46"
      className="prefix__cls-1"
    />
    <path
      d="m131.54 69.19.6.6c7.42 7.42 7.42 19.57 0 27.08l-.69.69c-2.5 2.41-6.55 2.41-8.97 0l-18.71-18.71c-2.5-2.41-2.5-6.47 0-8.97l.69-.69c7.42-7.42 19.57-7.42 27.08 0"
      style={{
        fill: 'none',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '3.89px',
        stroke: primaryColor || '#282828',
      }}
    />
  </svg>
);
export default PuntureDiMedusaIcon;
